import React from "react";
import { makeStyles } from "@mui/styles";
// import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import ReactStoreBadges from "react-store-badges";
import UAParser from "ua-parser-js";
import Section from "../components/Section";
import Simple from "../components/Simple";
import "semantic-ui-css/semantic.min.css";
import "react-multi-carousel/lib/styles.css";
// import Lottie from "lottie-react";
// import groovyWalkAnimation from "./../assets/lf30_editor_hxukfgoo.json";

// import FingerprintJS from "@fingerprintjs/fingerprintjs";
// import instance from "../api/api";

// const fpPromise = FingerprintJS.load();

// (async () => {
//   // Get the visitor identifier when you need it.
//   const fp = await fpPromise;
//   const result = await fp.get();

//   // This is the visitor identifier:
//   const visitorId = result.visitorId;

//   console.log(visitorId);
//   instance
//     .post(
//       "/users/share-app/61053d40d451f43175e0e111/61058e47f48c9466a3209bd8",
//       {visitorId}
//     )
//     .then(() => console.log("save data ..."))
//     .catch((e) => console.log("error: ", e.message));
// })();

// Print the 32bit hash id to the console

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    margin: 5,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

const Home = ({ t, i18n, deviceType }) => {
  const classes = useStyles();
  // useEffect(() => {
  //   console.log("finger: ", fingerprint);
  // }, []);

  return (
    <div className={classes.root}>
      {/* <Card className={classes.root}> */}
      <CardContent>
        <Typography variant="h6" component="p" style={{ marginTop: 2 }}>
          {t("appName")}
        </Typography>
        <Typography variant="body2" component="p" style={{ marginTop: 5 }}>
          {t("descriptionApp")}.
        </Typography>
        <Typography variant="h6" style={{ marginTop: 10 }}>
          {t("appContent")}:
        </Typography>
        <Typography variant="body2">- {t("privately")}.</Typography>
        <Typography variant="body2">- {t("liveChat")}.</Typography>
        {/* <Typography variant="body2">- {t("laterPayment")}.</Typography> */}
        <Typography variant="body2" style={{ marginBottom: 0 }}>
          - {t("removeDream")}.
        </Typography>

      
      {/* <CardContent align="center">
        <div style={{height:100,width:300 }}>
        <Lottie animationData={groovyWalkAnimation} loop={true} />;

        </div></CardContent> */}
      {/* <Typography
            variant="h6"
            style={{
              marginTop: 10,
              marginBottom: 10,
              backgroundColor: "black",
              color: "white",
            }}
          >
            COMMING SOON
          </Typography> */}

      {/* <> */}
        <Section>
          <Simple deviceType={deviceType} />
        </Section>
        {/* <CardContent align="center">
          <ReactStoreBadges
            platform={"ios"}
            url={"https://apps.apple.com/sa/app/6444057663?l=ar"}
            locale={"en-us"}
          />
          <ReactStoreBadges
            platform={"android"}
            url={
              "https://play.google.com/store/apps/details?id=com.adeb1991.ater"
            }
            locale={"en-us"}
          />
        </CardContent> */}
      {/* </> */}
      <ReactStoreBadges
            platform={"ios"}
            url={"https://apps.apple.com/sa/app/6444057663?l=ar"}
            locale={"en-us"}
          />
          <ReactStoreBadges
            platform={"android"}
            url={
              "https://play.google.com/store/apps/details?id=com.adeb1991.ater"
            }
            locale={"en-us"}
          />
      </CardContent>
      {/* </Card> */}
    </div>
  );
};

Home.getInitialProps = ({ req }) => {
  let userAgent;
  if (req) {
    userAgent = req.headers["user-agent"];
  } else {
    userAgent = navigator.userAgent;
  }
  const parser = new UAParser();
  parser.setUA(userAgent);
  const result = parser.getResult();
  const deviceType = (result.device && result.device.type) || "desktop";
  return { deviceType };
};

export default Home;
